import { useEffect, useState } from "react";
import styles from "./description.module.scss";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import SellModal from "../../../containers/Sell/SellModalContainer";
import Tag from "../../../components/Tag";
import TextField from "../../../components/TextField";
import { capitalize } from "../../../helpers/app";
import { DescriptionProps } from "../../../interfaces/salePost";
import { BsPlus } from 'react-icons/bs';
import { useToast } from "../../../helpers/hooks";
import { trackEvent } from "../../../config/firebase";

const Description = ({
    tags,
    brands,
    models,
    color,
    setTags,
    plate,
    isFoundPlate,
    userDescription,
    setUserDescription,
}: DescriptionProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    useEffect(() => {
        if (!plate) return navigate("/vender-auto");
    }, [plate]);

    useEffect(() => {
        trackEvent("venta-paso-descripción")
    },[])

    return (
        <SellModal
            step={isFoundPlate ? 5 : 7}
            title="Descripción"
            subTitle="Ingresa aquí un breve comentario a cerca de tu vehículo."
            onClickBack={() => navigate("/vender-auto/records")}
        
        >
            <div className={styles.inputsContainer}>
                <div className={styles.inputContent}>
                    <TextField
                        label="Describe el vehículo"
                        name="Describe el vehículo"
                        value={userDescription}
                        onChange={setUserDescription}
                        className={styles.input}
                        // error={inputTags?.error}
                        multiline={true}
                    />
                </div>
            </div>
            <Button
                onPress={() => navigate("/vender-auto/imagenes")}
                title="Continuar"
                primary
                className={styles.submitButton}
            />
        </SellModal>
    )
};

export default Description;